import React from 'react';
import { MDBDataTable } from 'mdbreact';
import '../../style/DataTable.css';

const TopPlayersDataTable = (props) => {
  const topPlayers = props?.topPlayers?.topPlayers;

  if (!topPlayers) return null;

  const getTopPlayersData = () => {
    let rowData = [];
    topPlayers.forEach((row) =>
      rowData.push({
        name: row.name,
        score: row.score,
        team: row.team,
      })
    );

    let totalScore = topPlayers.reduce((a, b) => a + (b['score'] || 0), 0);

    rowData.push({
      name: 'Kokku',
      score: totalScore,
      team: '',
    });

    if (!rowData.length) {
      rowData = [{ name: '' }];
    }

    return {
      columns: [
        {
          label: 'Nimi',
          field: 'name',
        },
        {
          label: 'Tulemus',
          field: 'score',
        },
        {
          label: 'Võistkond',
          field: 'team',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getTopPlayersData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default TopPlayersDataTable;
